import { makeApiCall } from '../../_common/api.utils';
import { API_URL } from '../../const';

/** ********************* START GET GOLD STOCK REPORT DETAILS ******************** */
export const GoldStockReportGet = (reportData: any) => {
	const data = {
		GoldStockReportToken: reportData,
	};
	const url = `${API_URL}GoldLoanStockReport`;
	return makeApiCall(url, data);
};
/** ********************* END GET GOLD STOCK REPORT DETAILS ******************** */
